/* Unilove BIS Inventory — updated 2026-11-04T01:18:25.653Z */
window.uniloveBISInventory = {
  "40822242967720": {"gb":191,"cn":0},
  "41624428413096": {"gb":9,"cn":0},
  "41624428445864": {"gb":10,"cn":0},
  "41624439619752": {"gb":0,"cn":0},
  "41624461705384": {"gb":0,"cn":20},
  "41624461738152": {"gb":175,"cn":20},
  "41719964827816": {"gb":0,"cn":50},
  "41719964958888": {"gb":0,"cn":0},
  "41719994319016": {"gb":93,"cn":50},
  "41720190009512": {"gb":188,"cn":0},
  "41720190042280": {"gb":89,"cn":0},
  "43006696947880": {"gb":1,"cn":0},
  "43218202656936": {"gb":0,"cn":0},
  "43218202689704": {"gb":95,"cn":20},
  "43225461719208": {"gb":0,"cn":0},
  "43515473166504": {"gb":191,"cn":0},
  "43515473199272": {"gb":6,"cn":0},
  "43921315004584": {"gb":45,"cn":50},
  "43921327849640": {"gb":45,"cn":50},
  "43921379917992": {"gb":0,"cn":0},
  "43921379950760": {"gb":-1,"cn":0},
  "43921379983528": {"gb":0,"cn":0},
  "43921380016296": {"gb":-1,"cn":0},
  "43921410949288": {"gb":-2,"cn":0},
  "44660531921064": {"gb":0,"cn":0},
  "44763401748648": {"gb":0,"cn":0},
  "44763401781416": {"gb":0,"cn":10},
  "44763401814184": {"gb":4,"cn":10},
  "44763401846952": {"gb":8,"cn":10},
  "48435907428520": {"gb":0,"cn":48},
  "48435914965160": {"gb":0,"cn":50},
  "49318686359720": {"gb":43,"cn":50},
  "49319253803176": {"gb":50,"cn":0},
  "49319253835944": {"gb":48,"cn":0},
  "49397313798312": {"gb":50,"cn":0},
  "49397327364264": {"gb":50,"cn":0},
  "49397353447592": {"gb":49,"cn":0},
  "49397379104936": {"gb":49,"cn":0},
  "50412164972712": {"gb":12,"cn":20},
  "50412180865192": {"gb":0,"cn":0},
  "50412186599592": {"gb":0,"cn":0},
  "50412192530600": {"gb":0,"cn":0},
  "50715589935272": {"gb":83,"cn":20},
  "50715594883240": {"gb":98,"cn":20},
  "52316818964648": {"gb":79,"cn":10},
  "52316818997416": {"gb":43,"cn":10},
  "52316819030184": {"gb":45,"cn":10},
  "52781876314280": {"gb":0,"cn":0},
  "54046571823272": {"gb":9,"cn":0},
  "54398087102632": {"gb":30,"cn":100},
  "54398087135400": {"gb":29,"cn":100},
  "54398087168168": {"gb":29,"cn":99},
  "54398087200936": {"gb":29,"cn":100},
  "54398087233704": {"gb":29,"cn":99},
  "55256766251176": {"gb":0,"cn":0},
  "55256766283944": {"gb":0,"cn":0},
  "55256766316712": {"gb":0,"cn":0},
  "55256766349480": {"gb":0,"cn":0},
  "55537237360808": {"gb":29,"cn":50},
  "55682348384424": {"gb":47,"cn":0}
};